import {createAction} from '@reduxjs/toolkit';
import {OrderingFilters, PaginatedTableFilters} from 'store/home/type';

export const enum APPARTAMENTI_TABLE_ACTION {
    SET_PAGE_INDEX = 'APPARTAMENTI_SET_PAGE_INDEX',
    SET_PAGE_SIZE = 'APPARTAMENTI_SET_PAGE_SIZE',
    SET_SEARCH_TABLE_DATA = 'APPARTAMENTI_SET_SEARCH_TABLE_DATA',
    SET_FILTERS = 'APPARTAMENTI_SET_FILTERS',
    SET_ORDERING_FILTERS = 'APPARTAMENTI_SET_ORDERING_FILTERS',
}

const setPageIndexAction = createAction(APPARTAMENTI_TABLE_ACTION.SET_PAGE_INDEX, (payload:number) => {
    return {payload}
})

const setPageSizeAction = createAction(APPARTAMENTI_TABLE_ACTION.SET_PAGE_SIZE, (payload:number) => {
    return {payload}
})

const setFiltersAction = createAction(APPARTAMENTI_TABLE_ACTION.SET_FILTERS, (payload:PaginatedTableFilters) => {
    return {payload}
})
const setOrderingFiltersAction = createAction(APPARTAMENTI_TABLE_ACTION.SET_ORDERING_FILTERS, (payload:OrderingFilters) => {
    return {payload}
})

export const AppartamentiTableAction = {
    setPageIndexAction,
    setPageSizeAction,
    setFiltersAction,
    setOrderingFiltersAction
};
